import classNames from 'classnames';
import React from 'react';

class StatsTable extends React.Component {
    static Stat = ({
        amount,
        label,
        horizontal = false,
    }: {
        amount: string | number;
        label: string;
        horizontal?: boolean;
    }) => (
        <div className={classNames('stat', { 'stat--horizontal': horizontal })}>
            <div className="stat__amount">{amount}</div>
            <div className="stat__label">{label}</div>
        </div>
    );

    render() {
        return (
            <div className="stats-table">
                {React.Children.map(this.props.children, child => (
                    <div className="stats-table__column">{child}</div>
                ))}
            </div>
        );
    }
}

export default StatsTable;
